import React from 'react';
import './Category.css';

import { Link } from 'react-router-dom';



const Category = (props) => {

  // Destructuring props
  const { index, category, count, image } = props;

  return (

    <div className={`category-item category-${index}`}>

      <img src={image} alt={category} /> {/* Category Image */}

      <div className="content">
        <div className="text">
          <div className="label">{count} cars available</div> {/* Number of Listings */}
          <Link to={`/Cars?carType=${encodeURIComponent(category)}`}> {/* Link to Filtered Cars Page */}
            <h3>{category}</h3> {/* Category Name */}
          </Link>
        </div>
      </div>

    </div>

  );
};

export default Category;